import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/hooks/useAuth';
import { keys } from '@/lib/queryKeys';
import { fetchBills } from './api';

/**
 * Branch-scoped — see HMS_V4_API_CONTRACT.md §5. branchVersion appended for
 * the same reason as every other migrated branch-scoped hook this session
 * (useTodayQueue.ts, useAppointmentSlots.ts): it forces a re-render at the
 * moment getActiveBranchId() already reflects a branch switch, closing the
 * race documented in queryKeys.ts's invalidateBranchScoped.
 */
export function useBills() {
  const { branchVersion } = useAuth();
  return useQuery({
    queryKey: [...keys.billing.list(), branchVersion],
    queryFn: fetchBills,
  });
}
